import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { personalities } from '../../../data/socionics/data/types'
import {whichRelationIsThis} from '../../../calculators/socionics/functions/whichRelation'
import {bblSort} from '../../../calculators/socionics/functions/bblSort'
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function SingleBar(props) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: true,
        text:  props.p1 ? `${props.p1} vs Other personalities` : `ESFP vs Other personalities`
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem) {
            return whichRelationIsThis(tooltipItem.raw)
          }
        }
      }
    },
    //change y axis labels to string
    scales: {
      y: {
        display: true,
        
      
        //change ticks to string
        ticks: {
          autoSkip: true,
          //stepSize: 1,
          callback: function(value) {
            return whichRelationIsThis(value)
          }
        }
      }
    },
  }

  let labels = personalities
  let dataU = props.data
  let colorU = ["#17a362","#6fe88c","#c3f78f","#e2f7a6","#e7f590", "#f5d878","#ffb266", "#f0cb48", "#f0ae07", "#cf9400", "#cf9400","#cf7500","#cf7500","#f7674a","#d91414","#a60396"]
  bblSort(dataU,labels,colorU)

  let data = {
    labels,
    datasets: [
      {
        label: 'Relation',
        data: dataU,
        backgroundColor: colorU,
      }
    ],
  };
  return (
    <Bar options={options} data={data} />)
}